(function () {
  function initSection(section) {
    if (section.dataset.wmtInit === "true") return;
    section.dataset.wmtInit = "true";

    /* ============ ACCORDION ============ */
    var heads = Array.prototype.slice.call(
      section.querySelectorAll(".wmt-panel-head[data-wmt-toggle]")
    );

    function bodyOf(head) {
      return head.nextElementSibling;
    }

    function collapse(body) {
      if (!body) return;
      // set explicit height first so the transition has a start value
      body.style.height = body.scrollHeight + "px";
      // force reflow, then animate to 0
      body.offsetHeight; // eslint-disable-line no-unused-expressions
      body.style.height = "0px";
    }

    function expand(body) {
      if (!body) return;
      body.style.visibility = "visible";
      body.style.height = body.scrollHeight + "px";
      // after the transition, release to auto so content can reflow
      var onEnd = function (e) {
        if (e.propertyName !== "height") return;
        body.style.height = "auto";
        body.removeEventListener("transitionend", onEnd);
      };
      body.addEventListener("transitionend", onEnd);
    }

    function openPanel(target, animate) {
      heads.forEach(function (head) {
        var isTarget = head === target;
        var body = bodyOf(head);
        head.setAttribute("aria-expanded", isTarget ? "true" : "false");
        if (!body) return;

        if (!animate) {
          body.style.transition = "none";
          if (isTarget) {
            body.style.height = "auto";
            body.style.visibility = "visible";
          } else {
            body.style.height = "0px";
            body.style.visibility = "hidden";
          }
          body.offsetHeight; // eslint-disable-line no-unused-expressions
          body.style.transition = "";
          return;
        }

        if (isTarget) {
          expand(body);
        } else {
          collapse(body);
          var hide = function (e) {
            if (e.propertyName !== "height") return;
            if (body.style.height === "0px") body.style.visibility = "hidden";
            body.removeEventListener("transitionend", hide);
          };
          body.addEventListener("transitionend", hide);
        }
      });
    }

    if (heads.length) {
      heads.forEach(function (head) {
        head.addEventListener("click", function () {
          // If this one is open, close it and open the other.
          // If it's closed, open it and close the rest.
          if (head.getAttribute("aria-expanded") === "true") {
            var other = heads.filter(function (h) { return h !== head; })[0];
            if (other) openPanel(other, true);
          } else {
            openPanel(head, true);
          }
        });
      });

      // Default: first panel open, no animation on load
      openPanel(heads[0], false);
    }

    /* ============ RING PULSE + POINTER PARALLAX ============ */
    initRingPulse(section);

    /* ============ IMAGE SLIDESHOW ============ */
    initSlideshow(section);
  }

  function initSlideshow(section) {
    var stage = section.querySelector("[data-wmt-stage]");
    if (!stage) return;

    var slides = Array.prototype.slice.call(
      stage.querySelectorAll("[data-wmt-slide]")
    );
    if (slides.length < 2) return; // nothing to rotate

    var interval = parseFloat(section.dataset.wmtSlideInterval);
    if (isNaN(interval) || interval <= 0) interval = 4;

    var idx = 0;
    var timer = null;

    // Ensure exactly one slide starts active
    slides.forEach(function (s, i) {
      s.classList.toggle("is-active", i === 0);
    });

    function next() {
      slides[idx].classList.remove("is-active");
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add("is-active");
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(next, interval * 1000);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    // Only cycle while the stage is on screen (saves work off-screen)
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start();
            } else {
              stop();
            }
          });
        },
        { threshold: 0.2 }
      );
      io.observe(stage);
    } else {
      start();
    }

    // Pause when the tab is hidden so slides don't jump on return
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        stop();
      } else if ("IntersectionObserver" in window) {
        // IO will restart it if still visible; nudge with a re-check
        var rect = stage.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) start();
      } else {
        start();
      }
    });
  }

  function initRingPulse(section) {
    var stage = section.querySelector("[data-wmt-stage]");
    if (!stage) return;

    var svg = stage.querySelector(".wmt-ring-svg");
    var outer = stage.querySelector(".wmt-ring-path--outer");
    var inner = stage.querySelector(".wmt-ring-path--inner");
    if (!svg || !outer || !inner) return;

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Read pulse config from data attributes (schema-driven), with fallbacks.
    var amp = parseFloat(section.dataset.wmtPulseAmp);
    if (isNaN(amp)) amp = 6;
    var freqOuter = parseInt(section.dataset.wmtPulseFreqOuter, 10);
    if (isNaN(freqOuter)) freqOuter = 14;
    var freqInner = parseInt(section.dataset.wmtPulseFreqInner, 10);
    if (isNaN(freqInner)) freqInner = 20;
    var alwaysOn = section.dataset.wmtPulseAlways === "true";

    // Shared centre radius for BOTH rings (schema-driven).
    var mid = parseFloat(section.dataset.wmtRingRadius);
    if (isNaN(mid)) mid = 176;

    // Gap between the two rings (schema-driven).
    var gap = parseFloat(section.dataset.wmtPulseGap);
    if (isNaN(gap)) gap = 12;
    var half = gap / 2;
    var outerBase = mid + half;    // outer waveform radius
    var innerBase = mid - half;    // inner waveform radius

    // Geometry inside the 400x400 viewBox.
    var CX = 200, CY = 200, STEPS = 200;
    var rings = [
      { el: outer, base: outerBase, amp: amp,        seed: 1.0, freq: freqOuter, dir: 1 },
      { el: inner, base: innerBase, amp: amp * 0.72, seed: 1.3, freq: freqInner, dir: -1 }
    ];

    function ringPath(ring, energy, t) {
      var d = "";
      for (var i = 0; i <= STEPS; i++) {
        var a = (i / STEPS) * Math.PI * 2 - Math.PI / 2;
        var wave =
          Math.sin(a * ring.freq + t * 2.2 * ring.dir * ring.seed) +
          0.4 * Math.sin(a * ring.freq * 2 + t * 1.3 * ring.dir);
        var r = ring.base + energy * ring.amp * (wave * 0.5 + 0.5) * ring.seed;
        var x = CX + Math.cos(a) * r;
        var y = CY + Math.sin(a) * r;
        d += (i === 0 ? "M" : "L") + x.toFixed(2) + " " + y.toFixed(2) + " ";
      }
      return d + "Z";
    }

    var active = alwaysOn;
    var energy = 0;
    var t = 0;
    var rafId = null;
    var running = false;

    function frame() {
      t += 0.05;
      var targetEnergy = active ? 1 : 0;
      energy += (targetEnergy - energy) * 0.08;

      rings.forEach(function (ring) {
        ring.el.setAttribute("d", ringPath(ring, energy, t));
      });

      // Keep animating until the rings have settled back to rest.
      if (active || energy > 0.001) {
        rafId = window.requestAnimationFrame(frame);
      } else {
        running = false;
        // draw one clean resting circle
        rings.forEach(function (ring) {
          ring.el.setAttribute("d", ringPath(ring, 0, t));
        });
      }
    }

    function start() {
      if (running) return;
      running = true;
      rafId = window.requestAnimationFrame(frame);
    }

    // Draw the resting rings immediately so they're visible before hover.
    rings.forEach(function (ring) {
      ring.el.setAttribute("d", ringPath(ring, 0, 0));
    });

    if (alwaysOn && !reduceMotion) {
      start();
    } else if (!reduceMotion) {
      stage.addEventListener("mouseenter", function () {
        active = true;
        start();
      });
      stage.addEventListener("mouseleave", function () {
        active = false;
        // frame() will ease energy down and stop itself
        start();
      });
      // touch: toggle the pulse on tap
      stage.addEventListener(
        "touchstart",
        function () {
          active = !active;
          start();
        },
        { passive: true }
      );
    }

    /* ---- pointer parallax / glow (rAF-batched to stop shivering) ---- */
    if (reduceMotion) return;

    var maxTilt = 8;   // deg
    var maxShift = 14; // px

    // Latest pointer state; the handler only records, a single rAF writes.
    var pending = false;
    var pRelX = 0.5, pRelY = 0.5;
    var haveRect = false, rLeft = 0, rTop = 0, rW = 1, rH = 1;

    function refreshRect() {
      var rect = stage.getBoundingClientRect();
      rLeft = rect.left;
      rTop = rect.top;
      rW = rect.width || 1;
      rH = rect.height || 1;
      haveRect = true;
    }

    function applyParallax() {
      pending = false;
      var dx = pRelX - 0.5; // -0.5..0.5
      var dy = pRelY - 0.5;

      stage.style.setProperty("--wmt-ry", (dx * maxTilt).toFixed(2) + "deg");
      stage.style.setProperty("--wmt-rx", (-dy * maxTilt).toFixed(2) + "deg");
      stage.style.setProperty("--wmt-px", (dx * maxShift).toFixed(2) + "px");
      stage.style.setProperty("--wmt-py", (dy * maxShift).toFixed(2) + "px");
      stage.style.setProperty("--wmt-glow-x", (pRelX * 100).toFixed(1) + "%");
      stage.style.setProperty("--wmt-glow-y", (pRelY * 100).toFixed(1) + "%");
      stage.style.setProperty("--wmt-glow-op", "1");
    }

    stage.addEventListener("pointerenter", refreshRect);

    stage.addEventListener("pointermove", function (e) {
      if (!haveRect) refreshRect();
      pRelX = (e.clientX - rLeft) / rW; // 0..1
      pRelY = (e.clientY - rTop) / rH;  // 0..1
      // clamp so an edge overshoot can't spike the transform
      if (pRelX < 0) pRelX = 0; else if (pRelX > 1) pRelX = 1;
      if (pRelY < 0) pRelY = 0; else if (pRelY > 1) pRelY = 1;

      if (!pending) {
        pending = true;
        window.requestAnimationFrame(applyParallax);
      }
    });

    // Rect can shift on scroll/resize while hovering — invalidate it.
    window.addEventListener("scroll", function () { haveRect = false; }, { passive: true });
    window.addEventListener("resize", function () { haveRect = false; }, { passive: true });

    stage.addEventListener("pointerleave", function () {
      haveRect = false;
      stage.style.setProperty("--wmt-rx", "0deg");
      stage.style.setProperty("--wmt-ry", "0deg");
      stage.style.setProperty("--wmt-px", "0px");
      stage.style.setProperty("--wmt-py", "0px");
      stage.style.setProperty("--wmt-glow-op", "0");
    });
  }

  function initAll() {
    document.querySelectorAll(".wmt-wrapper").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".wmt-wrapper");
    if (el) {
      el.dataset.wmtInit = "";
      initSection(el);
    }
  });
})();